module.exports = __webpack_public_path__ + "img/restaurant-prices.7da457bf.svg";